export const SUCCESS_MESSAGES = {
  passwordChangedSuccess: {
    hr: 'Uspješno ste izmijenili lozinku, u kratkome roku zaprimiti ćete e-mail s novom lozinkom.',
    en: 'You have successfully changed your password, you will shortly receive an e-mail with a new password.'
  },
  oldPasswordChangedSuccess: {
    hr: 'Uspješno ste izmijenili lozinku.',
    en: 'You have successfully changed your password.'
  },
  mailChangedSuccess: {
    hr: 'Uspješno ste izmijenili e-mail adresu.',
    en: 'You have successfully changed your email address.'
  },
  registrationSuccess: {
    hr: 'Uspješno ste se registrirali, u kratkome roku zaprimiti ćete e-mail s podacima za prijavu.',
    en: 'You have successfully registered, you will shortly receive an e-mail with login information.'
  },
  registrationWithPinSuccess: {
    hr: "Uspješno ste se registrirali, u kratkome roku zaprimiti ćete e-mail s PIN-om kojeg je potrebno unijeti u idućem koraku.",
    en: "You have successfully registered, you will shortly receive an e-mail with the PIN that needs to be entered in the next step."
  },
  profileUpdatedSuccess: {
    hr: 'Vaši podaci su uspješno ažurirani!',
    en: 'Your data has been successfully updated!'
  },
  membershipCardLinkedSuccess: {
    hr: 'Članska iskaznica je uspješno povezana s profilom.',
    en: 'Membership card successfully linked to profile.'
  },
  connectedSuccess: {
    hr: 'Uspješno povezano.',
    en: 'Successfully connected.'
  },
  ticketTransferedToEmailSuccess: {
    hr: 'Uspješno ste poslali ulaznicu na e-mail.',
    en: 'You have successfully sent the ticket to the email.'
  },
};